import { cn } from '@workspace/ui/lib/utils'

/** A filter pill with the size of its result beside it, as the Following and Search lists show them. */
export function FilterChip({
  label,
  count,
  active,
  onClick,
}: {
  label: string
  count?: number
  active: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs',
        active
          ? 'bg-elevated font-medium text-foreground'
          : 'text-muted-foreground transition-colors hover:bg-white/[0.04] hover:text-foreground'
      )}
    >
      {label}
      {count !== undefined && <span className="tabular-nums text-muted-foreground">{count}</span>}
    </button>
  )
}
